export enum ThemeEnum {
    Dark = 0,
    Light = 1,
    Blue = 2,
    Orange = 3,
}
//export enum ThemeColor {
//    Dark = "dark",
//    Light = "light",
//    Blue = "blue",
//    Orange = "orange"
//}
